import { useParams } from "react-router-dom";
import { ContactDetails } from "@/features/person/components/ContactDetails";
import { useQuery } from "@apollo/client";
import { PERSON_DETAILS_QUERY } from "./queries";
import { Person } from "@/types";
import { CardGridSkeleton } from "@/components/Skeleton";
import ErrorBoundary from "@/components/ErrorBoundary";

type PersonData = { person: Person };

export default function PersonContact() {
  const { pgaId } = useParams();

  const { data, error } = useQuery<PersonData>(PERSON_DETAILS_QUERY, {
    variables: { pgaId },
    fetchPolicy: "cache-first"
  });

  const { person } = data || {};

  if (error) {
    return (
      <ErrorBoundary
        variant="inline"
        title="Failed to Load Contact Details"
        message={error.message}
        className="mt-12"
      />
    );
  }

  if (!person) {
    return <CardGridSkeleton />;
  }

  return (
    <div>
      <ContactDetails person={person} />
    </div>
  );
}
